import styled from "@emotion/styled";

export const TooltipContent = styled.div<{ maxWidth?: number | string }>(props => ({
    fontSize: props.theme.candy.typography.primary.fontSize.css(),
    fontFamily: props.theme.candy.typography.fontFamily.regular,
    maxWidth: props.maxWidth ?? 240,
    display: "inline-block",
}));

export const Formula = styled.div({
    fontWeight: "bold",
});
